import { Component, Inject, Injector, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { WfsLayerComponent } from "./wfs-layer.component";
import { PhoenixWfsLayerResultsDialogComponent } from "../wfs-layer-results-dialog/phoenix-wfs-layer-results-dialog.component";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";

@Component({
  selector: "phoenix-wfs-component",
  templateUrl: "./wfs-layer.component.html",
  styleUrls: ["./wfs-layer.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixWfsLayerComponent extends WfsLayerComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    matDialog: MatDialog,
    public injector: Injector,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, matDialog);
  }

  loadLayers() {
    const dialog = this.matDialog.open(PhoenixWfsLayerResultsDialogComponent, {
      data: {
        viewerService: this.viewerService,
        url: this.url,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        useBbox: this.useBbox,
        isAuthRequired: this.isAuthRequired,
        layers: this.features,
        wfsFormat: this.format,
      },
      panelClass: "medium-panel-dialog",
      autoFocus: false,
      injector: this.injector,
    });
    dialog.afterClosed().subscribe(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "";
    });
  }

  getWFSFormatter() {
    return this.viewerService.getCoreMap().getWFSFormatter();
  }
}
